import React from 'react';
import IntroContent from "@/components/IntroContent";
import {motion} from "motion/react"
import {r} from "@/utils/responsive";

interface IntroTextLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const IntroTextLayer: React.FC<IntroTextLayerProps> = ({className, ...props}) => {
    return (
        <motion.div
            initial={{
                translateX: 0,
                translateY: 0,
                opacity: 0,
            }} animate={{
            translateX: 0,
            translateY: 0,
            opacity: 1,
        }} exit={{
            translateX: r.vmax(500),
            translateY: r.vmax(-500),
            opacity: 0,
        }} transition={{duration: .75, ease: 'easeInOut'}}
            style={{position: 'absolute', inset: 0, zIndex: 5}}
        >
            <IntroContent/>
        </motion.div>
    );
};

export default IntroTextLayer;
